module.exports = __webpack_public_path__ + "img/controlesimg4Acesso.c92e26a9.svg";